import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryContainer from '../../components/ErrorBoundaryContainer';
import Loading from '../../components/Loading';

const SplitScreenComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "dasvistapro-split-screen-page" */ '../../pages/dasvistapro-split-screen'
    ),
);

const dasVistaProSplitScreenRouter = (
  <Route
    path="dasvistapro-split-screen/:projectId"
    element={
      <Suspense fallback={<Loading />}>
        <ErrorBoundaryContainer
          key="dasvistapro-dashboard-split-screen"
          component={<SplitScreenComponent />}
        />
      </Suspense>
    }
  ></Route>
);

export default dasVistaProSplitScreenRouter;
